import { Link } from "react-router-dom";
import { Server, MapPin, Boxes } from "lucide-react";
import { cn } from "@/lib/utils";
import { StatusBadge } from "./StatusBadge";
import { ResourceStatus } from "./ResourceStatus";

// Card de servidor VPS (usado no Dashboard e página Servidores).
export const ServerCard = ({ server, compact = false }) => {
  const offline = server.status === "error" || server.status === "offline";
  return (
    <Link
      to={`/servidores/${server.id}`}
      data-testid={`server-card-${server.id}`}
      className={cn(
        "group block rounded-xl border border-line bg-surface p-4 transition-all duration-300 hover:border-line/60 hover:bg-surface-hover hover:-translate-y-0.5",
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className={cn("flex h-11 w-11 items-center justify-center rounded-lg border", offline ? "border-err/30 bg-err/10 text-err" : "border-line bg-white/[0.03] text-muted-foreground")}>
            <Server className="h-5 w-5" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-base font-semibold text-foreground">{server.hostname}</span>
              <span className="rounded border border-line px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground">{server.cpuCores}vCPU</span>
            </div>
            <p className="font-mono text-xs text-muted-foreground">{server.ip}</p>
          </div>
        </div>
        <StatusBadge status={server.status} size="sm" />
      </div>

      {!compact && (
        <div className="mt-3 flex items-center gap-3 text-[11px] text-muted-foreground">
          <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" />{server.region}</span>
          <span className="inline-flex items-center gap-1"><Boxes className="h-3 w-3" />{server.containers} containers</span>
        </div>
      )}

      <div className="mt-4 space-y-2.5">
        <ResourceStatus label="CPU" pct={server.cpuPct} />
        <ResourceStatus label="RAM" value={server.ramUsed} max={server.ramTotal} unit="GB" />
        <ResourceStatus label="Disco" value={server.diskUsed} max={server.diskTotal} unit="GB" />
      </div>
    </Link>
  );
};
